/**
 * @generated SignedSource<<cc0187bb9815d5ca681c1118a81ba7f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BasisEnum = "CASH" | "NORMALIZED" | "%future added value";
export type pnlPage_ExportMutation$variables = {
  basis?: BasisEnum | null | undefined;
  perspectiveId?: string | null | undefined;
};
export type pnlPage_ExportMutation$data = {
  readonly exportCreate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly export: {
      readonly id: string;
      readonly status: string;
    } | null | undefined;
  } | null | undefined;
};
export type pnlPage_ExportMutation = {
  response: pnlPage_ExportMutation$data;
  variables: pnlPage_ExportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "basis",
    "variableName": "basis"
  },
  {
    "kind": "Literal",
    "name": "kind",
    "value": "PNL_FULL"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Export",
  "kind": "LinkedField",
  "name": "export",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlPage_ExportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ExportCreateMutationPayload",
        "kind": "LinkedField",
        "name": "exportCreate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "pnlPage_ExportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ExportCreateMutationPayload",
        "kind": "LinkedField",
        "name": "exportCreate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ac50cc0db4971bd73c28f7beac3461d",
    "id": null,
    "metadata": {},
    "name": "pnlPage_ExportMutation",
    "operationKind": "mutation",
    "text": "mutation pnlPage_ExportMutation(\n  $perspectiveId: ID\n  $basis: BasisEnum\n) {\n  exportCreate(kind: \"PNL_FULL\", perspectiveId: $perspectiveId, basis: $basis) {\n    export {\n      id\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e5c88646b7551742f4ef55aaf197470";

export default node;
